"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconChevronDownCircleOutline = _interopRequireDefault(require("./IconChevronDownCircleOutline"));
var IconChevronLeftCircleOutline = /*#__PURE__*/(0, _styledComponents.default)(_IconChevronDownCircleOutline.default).withConfig({
  displayName: "IconChevronLeftCircleOutline",
  componentId: "c11n-8-107-0__sc-gzehhl-0"
})(["transform:rotate(90deg);"]);
var _default = IconChevronLeftCircleOutline;
exports.default = _default;